import { apiFetch } from '../client';

/** "Tus solicitudes" de las Alertas de Inicio. Server: server/src/routes/alertas.ts. */
export type Resolucion = {
  /** '<tipo>:<id>' — lo que se guarda al descartarla. */
  key: string;
  tipo: string;
  resultado: 'Aprobado' | 'Rechazado';
  detalle: string;
  motivo: string | null;
  ventaId: number | null;
  cliente: string | null;
  resueltoAt: string;
};

export async function listResoluciones(): Promise<Resolucion[]> {
  const r = await apiFetch<{ items: Resolucion[] }>('/api/alertas/resoluciones');
  return r.items;
}

export async function descartarAlertas(keys: string[]): Promise<void> {
  await apiFetch('/api/alertas/descartar', { method: 'POST', body: { keys } });
}

/** Importación abierta por llegar o ya pasada de su fecha probable (admin/administración). */
export type ImportacionArribo = {
  /** Incluye la fecha: si la reprograman, vuelve a avisar. */
  key: string;
  id: number;
  numero: number;
  descripcion: string;
  fechaProbable: string;
};

export async function listImportacionesArribo(): Promise<ImportacionArribo[]> {
  const r = await apiFetch<{ items: ImportacionArribo[] }>('/api/alertas/importaciones-arribo');
  return r.items;
}

/** E-cheq rechazado por el banco con el horno ya despachado (admin/administración). */
export type EcheqRebotado = {
  key: string;
  nroCheque: string;
  banco: string;
  monto: number;
  motivo: string | null;
  ventaId: number;
  cliente: string | null;
  ventaStatus: string;
  rechazadoAt: string;
};

export async function listEcheqsRebotados(): Promise<EcheqRebotado[]> {
  const r = await apiFetch<{ items: EcheqRebotado[] }>('/api/alertas/echeqs-rebotados');
  return r.items;
}

/** Etapa del ciclo de vida de una importación abierta, por vencer o vencida (admin/administración). */
export type ImportacionEtapaAviso = {
  /** `importacion-etapa:{etapaId}:{fin}`: si la etapa se corre, vuelve a avisar. */
  key: string;
  importacionId: number;
  numero: number;
  descripcion: string;
  etapaId: number;
  etapa: string;
  /** Fin planificado, yyyy-mm-dd. */
  fin: string;
  tipo: 'proxima' | 'hoy' | 'vencida';
  /** Días que faltan (proxima) o que pasaron (vencida). */
  dias: number;
};

export async function listImportacionesEtapas(): Promise<ImportacionEtapaAviso[]> {
  const r = await apiFetch<{ items: ImportacionEtapaAviso[] }>('/api/alertas/importaciones-etapas');
  return r.items;
}
